/* eslint-disable*/
import BaseBridge from '@didi/mfe-webview-util/lib/base';
import { passenger } from '@didi/mfe-webview-util/lib/configuration/communication/passenger';
import { didies } from '@didi/mfe-webview-util/lib/configuration/communication/didies';
import { kflowerPassenger } from '@didi/mfe-webview-util/lib/configuration/communication/kflowerPassenger';
import { runtime, isWxMiniprogram, isAliMiniprogram } from '@/utils/runtime';
import loadScript from 'load-script';
import { GpuxOmegaNew } from '@didi/gpux-utils';

let globalOmegaAttrs = {};
export const omegaNew = GpuxOmegaNew;
omegaNew.initTracker({
  appKey: 'omega4bd37cd9e2',
  browserRouterEnable: true,
  attrs: {
    _activity_id: '0',
    _activity_name: '受理中心'
  },
  autoGolden: false
});

export const ddbridge = new BaseBridge({ passenger, didies, kflowerPassenger });
ddbridge.config.errorHandler = (err, app) => {
  console.log(
    `${err.message}, env: ${app.env}, communication: ${app.communication}`
  );
};

export const globalSetOmega = (attrs = {}) => {
  globalOmegaAttrs = attrs
}

export const locationReplace = url => {
  if (window.history.replaceState) {
    try {
      history.replaceState(null, document.title, url);
      history.go(0);
    } catch (err) {
      //history.replaceState不支持跨域
      if (navigator.userAgent.match(/Android/i)) {
        //andorid不支持replace,表现为普通的跳转
        setTimeout(() => {
          location.replace(url);
        }, 500);
      } else {
        window.location.replace(url);
      }
    }
  } else {
    window.location.replace(url);
  }
};

export const setTitle = (title = '') => {
  const state = ddbridge.isSupport('setTitle');
  if (state) {
    ddbridge.call('setTitle', {
      title: title
    });
  } else {
    document.title = title;
    let iframe = document.createElement('iframe');
    let isDev = process.env.NODE_ENV === 'development';
    iframe.style.visibility = 'hidden';
    iframe.style.display = 'none';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    if (isDev) {
      iframe.src = '';
    } else {
      iframe.src = `${location.protocol}//${location.hostname}/OnoUszX2aW.txt`; // 加载自身机器上的一个文件，触发onload
    }
    iframe.onload = function () {
      setTimeout(function () {
        document.body.removeChild(iframe);
      }, 0);
    };
    document.body.appendChild(iframe);
  }
};

export function getUserInfo() {
  return new Promise((resolve, reject) => {
    const state = ddbridge.isSupport('getUserInfo');
    if (state) {
      ddbridge.call('getUserInfo', function (err, data) {
        if (!err) {
          console.log('user succ: ', data);
          resolve(data);
        } else {
          console.log('user err: ', err);
          reject(err);
        }
      });
    } else {
      reject('当前客户端不支持JSBridge方法');
    }
  });
}

export function getLocationInfo() {
  return new Promise((resolve, reject) => {
    const state = ddbridge.isSupport('getLocationInfo');
    if (state) {
      ddbridge.call('getLocationInfo', { forceLocation: 1 }, function (
        err,
        data
      ) {
        if (!err) {
          console.log('getLocationInfo succ: ', data);
          resolve(data);
        } else {
          console.log('getLocationInfo err: ', err);
          reject(err);
        }
      });
    } else {
      reject('当前客户端不支持JSBridge方法');
    }
  });
}

export function openPage(url) {
  const state = ddbridge.isSupport('openPage');
  if (state) {
    ddbridge.call('openPage', {
      target: 'blank',
      url: url
    });
  } else {
    location.href = url;
  }
}

export const WXJSSDK = () => {
  const url = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
  return new Promise((resolve, reject) => {
    if (window.wx) {
      resolve(true);
    } else {
      loadScript(url, (err, script) => {
        if (err) {
          reject(err);
        } else {
          resolve(script);
        }
      });
    }
  });
};

export const ALISSDK = () => {
  const url = 'https://appx/web-view.min.js';
  return new Promise((resolve, reject) => {
    if (window.my) {
      resolve(true);
    } else {
      loadScript(url, (err, script) => {
        if (err) {
          reject(err);
        } else {
          resolve(script);
        }
      });
    }
  });
};

export const closePage = () => {
  if (runtime.is('app') && ddbridge.isSupport('closePage')) {
    ddbridge.call('closePage');
  } else if (isWxMiniprogram()) {
    WXJSSDK().then(() => {
      window.wx.miniProgram.navigateBack({
        delta: 1
      });
    });
  } else if (isAliMiniprogram()) {
    ALISSDK().then(() => {
      window.my.navigateBack({
        delta: 1
      });
    });
  } else if (runtime.is('quickApp')) {
    system && system.postMessage('closeWindow');
  } else {
    window.history.go(-1);
  }
};

export const Omega = ({ eventId = null, eventLabel = '', attrs = {}, prefix = '' }) => {
  const Omega = omegaNew;
  if (!eventId) {
    return Promise.reject('请输入eventId');
  }
  let event_str = '';
  if (prefix) {
    event_str += prefix;
  }
  return new Promise((resolve, reject) => {
    Omega.trackEvent(`${event_str}${eventId}`, eventLabel, Object.assign(globalOmegaAttrs, attrs))
      .then(event => {
        resolve(event.getData());
      })
      .catch(err => {
        reject(err);
      });
  });
};

export function systemInfo() {
  return new Promise((resolve, reject) => {
    const state = ddbridge.isSupport('getSystemInfo');
    if (state) {
      ddbridge.call('getSystemInfo', function (err, data) {
        if (!err) {
          console.log('SystemInfo succ: ', data);
          resolve(data);
        } else {
          console.log('SystemInfo err: ', err);
          reject(err);
        }
      });
    } else {
      reject('当前客户端不支持JSBridge方法');
    }
  });
}

